import type { User } from '@/types'

/**
 * The console a signed-in team member belongs to.
 *
 * This replaced three separate admin-or-staff ternaries that all fell through
 * to "Production floor", so a sales user was offered the shop floor and a QR
 * icon they had no access to. Add a role here, not in a component.
 */
export function consoleFor(user: User | null): { to: string; label: string; icon: 'gauge' | 'qr' | 'receipt' } {
  if (user?.role === 'admin') return { to: '/admin', label: 'Admin console', icon: 'gauge' }
  if (user?.role === 'sales') return { to: '/sales', label: 'Sales console', icon: 'receipt' }
  if (user?.role === 'partner') return { to: '/partner', label: 'Partner portal', icon: 'qr' }
  return { to: '/staff', label: 'Production floor', icon: 'qr' }
}

/**
 * The orders list of a console. Not `${basePath}/orders`: the sales console
 * opens on its orders list at `/sales`, so `/sales/orders` hit the catch-all
 * and dropped a sales user on the marketplace after creating an order.
 */
export function ordersListPath(basePath: '/admin' | '/sales'): string {
  return basePath === '/sales' ? '/sales' : '/admin/orders'
}

/** Where a team member's own profile page lives in their console. */
export function profilePath(user: User | null): string {
  return `${consoleFor(user).to}/profile`
}
